import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d746c546"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "pop"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "df jc-right" }
const _hoisted_6 = {
  key: 1,
  class: "d-wrapper"
}
const _hoisted_7 = { class: "case-nav" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-edit" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close-light" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cancel", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "d-pop"
}
const _hoisted_14 = { class: "d-pop__wrapper" }
const _hoisted_15 = { class: "d-pop__left" }
const _hoisted_16 = { class: "d-pop__right" }
const _hoisted_17 = { class: "d-pop__scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_drive_input = _resolveComponent("drive-input")!
  const _component_drive_files = _resolveComponent("drive-files")!
  const _component_app_label_input = _resolveComponent("app-label-input")!
  const _component_drive_ui_wrapper = _resolveComponent("drive-ui-wrapper")!
  const _component_drive_info = _resolveComponent("drive-info")!
  const _component_drive_location = _resolveComponent("drive-location")!
  const _component_move_to_pop_up = _resolveComponent("move-to-pop-up")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_skeleton_case_view = _resolveComponent("app-skeleton-case-view")!
  const _component_app_skeleton_case_edit = _resolveComponent("app-skeleton-case-edit")!
  const _component_desktop_upload_progress = _resolveComponent("desktop-upload-progress")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.dataLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_app_header, {
                customTitle: _ctx.driveStore.currentCase.title,
                countPadding: ""
              }, {
                "top-left": _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:void(0);",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.backAction && _ctx.backAction(...args)), ["prevent"])),
                    class: "back-link"
                  }, _hoisted_4)
                ]),
                "top-right": _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateCase && _ctx.updateCase(...args))),
                      class: _normalizeClass(["link", { disabled: _ctx.isDoneDisabled }])
                    }, " Done ", 2)
                  ])
                ]),
                _: 1
              }, 8, ["customTitle"]),
              _createVNode(_component_drive_input, {
                title: _ctx.$localize('edit.case.title'),
                placeholder: _ctx.$localize('edit.case.title.placeholder'),
                modelValue: _ctx.driveStore.bufferCurrentCaseTitle,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.driveStore.bufferCurrentCaseTitle) = $event)),
                hideBorder: _ctx.driveStore.caseTitleValidation ? _ctx.HIDE_BORDER.NONE : _ctx.HIDE_BORDER.BOTTOM,
                error: _ctx.driveStore.caseTitleValidation,
                onInput: _ctx.validateCaseTitle,
                enterkeyhint: "next"
              }, null, 8, ["title", "placeholder", "modelValue", "hideBorder", "error", "onInput"]),
              _createVNode(_component_drive_input, {
                class: "case-description",
                title: _ctx.$localize('edit.case.description.title'),
                placeholder: _ctx.$localize('edit.case.description.placeholder'),
                modelValue: _ctx.driveStore.currentCase.description,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.driveStore.currentCase.description) = $event)),
                hideBorder: _ctx.HIDE_BORDER.BOTTOM,
                error: _ctx.driveStore.caseDescriptionValidation,
                onInput: _ctx.validateCaseDescription
              }, null, 8, ["title", "placeholder", "modelValue", "hideBorder", "error", "onInput"]),
              _createVNode(_component_drive_files, {
                files: _ctx.driveStore.currentCase.photos,
                title: _ctx.$localize('edit.case.media.type.photo'),
                hideBorder: _ctx.HIDE_BORDER.BOTTOM,
                "skeleton-amount": _ctx.currentCasePhotoSkeletons[_ctx.driveStore.currentCase.id!],
                isPhoto: ""
              }, null, 8, ["files", "title", "hideBorder", "skeleton-amount"]),
              _createVNode(_component_drive_files, {
                files: _ctx.driveStore.currentCase.files,
                title: _ctx.$localize('edit.case.media.type.file'),
                hideBorder: _ctx.HIDE_BORDER.BOTTOM,
                "skeleton-amount": _ctx.currentCaseFileSkeletons[_ctx.driveStore.currentCase.id!]
              }, null, 8, ["files", "title", "hideBorder", "skeleton-amount"]),
              _createVNode(_component_drive_ui_wrapper, {
                title: _ctx.$localize('edit.case.labels'),
                hideBorder: _ctx.HIDE_BORDER.BOTTOM,
                id: 'labelsInput'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_app_label_input, {
                    onOnUpdateTags: _ctx.updateTags,
                    onOnFocus: _ctx.setFocusOnLabels
                  }, null, 8, ["onOnUpdateTags", "onOnFocus"])
                ]),
                _: 1
              }, 8, ["title", "hideBorder"]),
              _createVNode(_component_drive_info, {
                created: _ctx.formatDate(_ctx.driveStore.currentCase.created),
                updated: _ctx.formatDate(_ctx.driveStore.currentCase.updated)
              }, null, 8, ["created", "updated"]),
              _createVNode(_component_drive_location, {
                title: _ctx.$localize('edit.case.location'),
                currentPosition: _ctx.currentFolderText,
                showDots: _ctx.showDots,
                onOpenMoveToPopUp: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isMoveToCasePopUp = true))
              }, null, 8, ["title", "currentPosition", "showDots"]),
              (_ctx.isMoveToCasePopUp)
                ? (_openBlock(), _createBlock(_component_move_to_pop_up, {
                    key: 0,
                    item: _ctx.driveStore.currentCase!,
                    "item-type": _ctx.SHARE_TYPES.CASE,
                    onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isMoveToCasePopUp = false)),
                    onUpdateLocation: _ctx.updateLocation,
                    class: "popUp-fixed"
                  }, null, 8, ["item", "item-type", "onUpdateLocation"]))
                : _createCommentVNode("", true),
              _createVNode(_component_app_button, {
                onClick: _ctx.updateCase,
                class: _normalizeClass(["save-button", { disabled: _ctx.isDoneDisabled }])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$localize('edit.case.done.button')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "class"]),
              (_ctx.isProgress)
                ? (_openBlock(), _createBlock(_component_app_skeleton_case_view, {
                    key: 1,
                    title: _ctx.driveStore.currentCase.title,
                    "file-skeletons": _ctx.driveStore.currentCase.files.length,
                    "photo-skeletons": _ctx.driveStore.currentCase.photos.length
                  }, null, 8, ["title", "file-skeletons", "photo-skeletons"]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock(_component_app_skeleton_case_edit, {
              key: 1,
              title: _ctx.driveStore.currentCase.title,
              "file-skeletons": _ctx.driveStore.currentCase.filesAmount,
              "photo-skeletons": _ctx.driveStore.currentCase.photosAmount
            }, null, 8, ["title", "file-skeletons", "photo-skeletons"]))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("h3", null, _toDisplayString(_ctx.$localize('edit.case')), 1)
          ]),
          _createElementVNode("div", {
            class: "cancel-button",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.backAction && _ctx.backAction(...args)))
          }, _hoisted_12)
        ]),
        (!_ctx.dataLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_ctx.mainStore.uploadInfos.length)
                ? (_openBlock(), _createBlock(_component_desktop_upload_progress, {
                    key: 0,
                    uploadInfo: _ctx.mainStore.getUploadInfo
                  }, null, 8, ["uploadInfo"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_drive_input, {
                    title: _ctx.$localize('edit.case.title'),
                    placeholder: _ctx.$localize('edit.case.title.placeholder'),
                    modelValue: _ctx.driveStore.bufferCurrentCaseTitle,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.driveStore.bufferCurrentCaseTitle) = $event)),
                    hideBorder: _ctx.driveStore.caseTitleValidation ? _ctx.HIDE_BORDER.TOP : _ctx.HIDE_BORDER.TOP,
                    error: _ctx.driveStore.caseTitleValidation,
                    onInput: _ctx.validateCaseTitle,
                    enterkeyhint: "next"
                  }, null, 8, ["title", "placeholder", "modelValue", "hideBorder", "error", "onInput"]),
                  _createVNode(_component_drive_input, {
                    class: "case-description",
                    title: _ctx.$localize('edit.case.description.title'),
                    placeholder: _ctx.$localize('edit.case.description.placeholder'),
                    modelValue: _ctx.driveStore.currentCase.description,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.driveStore.currentCase.description) = $event)),
                    hideBorder: _ctx.HIDE_BORDER.TOP,
                    error: _ctx.driveStore.caseDescriptionValidation,
                    onInput: _ctx.validateCaseDescription
                  }, null, 8, ["title", "placeholder", "modelValue", "hideBorder", "error", "onInput"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_drive_files, {
                      files: _ctx.driveStore.currentCase.photos,
                      title: _ctx.$localize('edit.case.media.type.photo'),
                      hideBorder: _ctx.HIDE_BORDER.TOP,
                      "skeleton-amount": _ctx.currentCasePhotoSkeletons[_ctx.driveStore.currentCase.id!],
                      isPhoto: true
                    }, null, 8, ["files", "title", "hideBorder", "skeleton-amount"]),
                    _createVNode(_component_drive_files, {
                      files: _ctx.driveStore.currentCase.files,
                      title: _ctx.$localize('edit.case.media.type.file'),
                      hideBorder: _ctx.HIDE_BORDER.TOP,
                      "skeleton-amount": _ctx.currentCaseFileSkeletons[_ctx.driveStore.currentCase.id!]
                    }, null, 8, ["files", "title", "hideBorder", "skeleton-amount"]),
                    _createVNode(_component_drive_ui_wrapper, {
                      title: _ctx.$localize('edit.case.labels'),
                      hideBorder: _ctx.HIDE_BORDER.TOP,
                      id: 'labelsInput'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_app_label_input, {
                          onOnUpdateTags: _ctx.updateTags,
                          onOnFocus: _ctx.setFocusOnLabels
                        }, null, 8, ["onOnUpdateTags", "onOnFocus"])
                      ]),
                      _: 1
                    }, 8, ["title", "hideBorder"]),
                    _createVNode(_component_drive_info, {
                      created: _ctx.formatDate(_ctx.driveStore.currentCase.created),
                      updated: _ctx.formatDate(_ctx.driveStore.currentCase.updated)
                    }, null, 8, ["created", "updated"]),
                    _createVNode(_component_drive_location, {
                      title: _ctx.$localize('edit.case.location'),
                      currentPosition: _ctx.currentFolderText,
                      showDots: _ctx.showDots,
                      onOpenMoveToPopUp: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isMoveToCasePopUp = true))
                    }, null, 8, ["title", "currentPosition", "showDots"]),
                    (_ctx.isMoveToCasePopUp)
                      ? (_openBlock(), _createBlock(_component_move_to_pop_up, {
                          key: 0,
                          item: _ctx.driveStore.currentCase!,
                          "item-type": _ctx.SHARE_TYPES.CASE,
                          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isMoveToCasePopUp = false)),
                          onUpdateLocation: _ctx.updateLocation
                        }, null, 8, ["item", "item-type", "onUpdateLocation"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_app_button, {
                    onClick: _ctx.updateCase,
                    class: _normalizeClass(["save-button", { disabled: _ctx.isDoneDisabled }])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$localize('edit.case.done.button')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "class"])
                ])
              ]),
              (_ctx.isProgress)
                ? (_openBlock(), _createBlock(_component_app_skeleton_case_view, {
                    key: 1,
                    title: _ctx.driveStore.currentCase.title,
                    "file-skeletons": _ctx.driveStore.currentCase.files.length,
                    "photo-skeletons": _ctx.driveStore.currentCase.photos.length
                  }, null, 8, ["title", "file-skeletons", "photo-skeletons"]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock(_component_app_skeleton_case_edit, {
              key: 1,
              title: _ctx.driveStore.currentCase.title,
              "file-skeletons": _ctx.driveStore.currentCase.filesAmount,
              "photo-skeletons": _ctx.driveStore.currentCase.photosAmount
            }, null, 8, ["title", "file-skeletons", "photo-skeletons"]))
      ]))
}